module.exports = __webpack_public_path__ + "img/block2_poligrafia.15acb0be.png";